import { useQuery, UseQueryResult } from '@tanstack/react-query'
import { AxiosError } from 'axios'

import { request } from '../../../../1stlog-ui/src/utils'
import { UseQueryOptionsWithOptionalKeyAndFn } from '../../../../1stlog-ui/types/UtilityTypes'

type StatisticsPayload = void

type StatisticsResponse = {
  delivered: number
  deliveryIssue: number
  negative: number
}

export function useGetStatistics(
  payload: StatisticsPayload,
  options?: UseQueryOptionsWithOptionalKeyAndFn<
    StatisticsResponse,
    AxiosError,
    StatisticsResponse,
    string[]
  >,
): UseQueryResult<StatisticsResponse> {
  const getStatistics = async (): Promise<StatisticsResponse> => {
    const { data } = await request<StatisticsResponse>({
      url: `/api/orderlisting/statistics`,
      method: 'GET',
    })
    return data
  }

  return useQuery({
    queryKey: ['statistics'],
    queryFn: () => getStatistics(),
    retry: false,
    ...options,
  })
}
